<template>
    <div class="sim-card-box">
        <p class='select-text'>
            {{title}}
            <span
                class="selected"
            >{{ cardId }}</span>
        </p>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
export default Vue.extend({
    props: {
        title:String,
        cardId: String
    }
});
</script>

<style lang="less" scoped>
.sim-card-box{
    background-color: @bg_02;
    border-radius: @border-radius-level-2;
    margin-bottom: 24px;

    padding: 32px;
    @media @mobile{
        padding: 16px;
        margin-bottom: 20px;
    }
    .select-text{
        font-family: @font_02;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        @media @snapeak_pc{
            font-size: @sim-selection-title-font-size;
            font-weight: @sim-selection-title-font-weight;
            line-height: 1.2;
            color: @font_primary;
            align-items: center;
        }
        @media @snapeak_mobile{
            font-size: @sim-selection-title-font-size-mobile;
            font-weight: @sim-selection-title-font-weight;
            line-height: 1;
            flex-direction: column;
            align-items: flex-start;
        }
        .selected{
            .text-hover();
            display: flex;
            font-size: @sim-selection-title-font-size;
            line-height: 1.2;
            align-items: center;
            @media @snapeak_mobile{
                font-size: @sim-selection-title-font-size-mobile;
            }
            &:hover{
                cursor: unset;
            }
        }
    }

    }
</style>
